import { Button } from 'primereact/button';
import { Panel } from 'primereact/panel';

const EliminaUsuarioRol = ({ rol, lstUser, onElimina }) => {

  const handleClick = async() => {
    onElimina()
  }
    return (
        <div className="card">
            <h4>
                Rol: <strong>{rol.nombre}</strong>{' '}
            </h4>
            <div className="formgrid grid p-fluid mb-3">
                <div className="field col-12 md:col-12">
                    <Panel header="Usuario para eliminar">
                        <ul>
                            {lstUser.map((item) => (
                                <li key={item.usuarioId}>{item.usuarioUserName}</li>
                            ))}
                        </ul>
                    </Panel>
                </div>
                <div className="field col-12 md:col-12">
                    <Button label="Eliminar" onClick={handleClick} />
                </div>
            </div>
        </div>
    );
};

export default EliminaUsuarioRol;
